<template>
  <div class="table-wrapper">
    <table class="table table-striped">
      <thead>
        <tr>
          <th class="w-25">Pos.</th>
          <th class="w-25">{{ name }}</th>
          <th class="w-25">Cnt.</th>
          <th class="w-25">Perc.</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in items" :key="item.id">
          <td class="w-25">{{ item.ord }}</td>
          <td class="w-25">{{ item.name }}</td>
          <td class="w-25">{{ item.cnt }}</td>
          <td class="w-25">{{ item.percentDisplay }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  
</template>

<script>
export default {
    props: ["items", "name"]
};
</script>
